export function getLocales(lang, namespaces = []) {
    let result = []

    if (namespaces && namespaces instanceof Array) {
        for (let namespaceId in namespaces) {
            let fileKey = namespaces[namespaceId]
            result[fileKey] = require(`./${lang}/generated/${fileKey}.json`)
        }
    } else {
        result = { 'common': require(`./${lang}/generated/common.json`) }
    }

    return result
}

/**
 * Get default user language
 *
 * @return {string}
 */
export const getDefaultLanguage = () => (window?.navigator?.language || window?.navigator?.userLanguage || 'cs').split('-')[0]


/**
 * Get language code
 *
 * @returns {string}
 */
export const languageCode = () => window.APP_CONFIG.REACT_APP_SYSTEM === 'sportnect' ? window.location.pathname.substring(1, 3) : null

/**
 * Get full language path
 *
 * @param {boolean} startSeparator
 * @param {boolean} endSeparator
 * @returns {string}
 */
export const languagePath = (startSeparator = false, endSeparator = false) => (
    languageCode() ? `${startSeparator ? '/' : ''}${languageCode()}${endSeparator ? '/' : ''}` : ''
)

/**
 * Get languages fallback
 *
 * @param {string} language
 * @return {string}
 */
export const getLanguageFallback = language => {
    switch (language) {
        case 'sk':
            return 'cs'
        default:
            return 'en'
    }
}
